import { createSlice } from '@reduxjs/toolkit'
import * as _ from 'lodash'

const initialState = {
  modalObject: {},
  // Vehicle-Info Fees States
  vehicleFees: {
    IS_PET_ALLOWED: false,
    BASE: 0,
    BOOKING: 0,
    CANCELLATION: 0,
    MIN_CHARGES: 0,
    PER_MILE: 0,
    PER_MINUTE: 0,
  },
  sidebarShow: true,
  sidebarUnfoldable: false,
  hasNewRental: false,
  hasNewDeposit: false,
  latestRentalNotification: null,
  latestDepositNotification: null,
  // if key doesn't exist then it will return null
  adminToken: localStorage.getItem('authToken'),
  showLoader: false,
  adminType: localStorage.getItem('type'),
  profile: {
    email: localStorage.getItem('email'),
    type: localStorage.getItem('type'),
    username: localStorage.getItem('username'),
    uid: localStorage.getItem('id'),
  },
  poolingInterval: _.isEmpty(localStorage.getItem('poolingInterval'))
    ? 600000
    : localStorage.getItem('poolingInterval'),
  timeOutValue: _.isEmpty(localStorage.getItem('timeOutValue'))
    ? 6000000
    : localStorage.getItem('timeOutValue'),
  timeZone: 'America/Caracas',
}

export const generalSlice = createSlice({
  name: 'generalSlice',
  initialState,
  reducers: {
    setSideBarShow: (state, action) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.sidebarShow = action.payload.show
    },
    setSideBarUnfoldable: (state, action) => {
      state.sidebarUnfoldable = action.payload.foldable
    },
    setAdminToken: (state, action) => {
      localStorage.setItem('authToken', action.payload.token)
      state.adminToken = action.payload.token
    },
    setShowLoader: (state, action) => {
      state.showLoader = action.payload.show
    },
    setAdminType: (state, action) => {
      localStorage.setItem('type', action.payload.type)
      state.adminType = action.payload.type
    },
    deleteAdminToken: (state, action) => {
      localStorage.clear()
      state.adminToken = null
    },
    setProfile: (state, action) => {
      localStorage.setItem('email', action.payload.profile.email)
      state.profile.email = action.payload.profile.email
      localStorage.setItem('type', action.payload.profile.type)
      state.profile.type = action.payload.profile.type
      localStorage.setItem('username', action.payload.profile.username)
      state.profile.username = action.payload.profile.username
      localStorage.setItem('id', action.payload.profile.uid)
      state.profile.uid = action.payload.profile.uid
    },
    setPoolingInterval: (state, action) => {
      localStorage.setItem('poolingInterval', action.payload.poolingInterval)
      state.poolingInterval = action.payload.poolingInterval
    },
    setTimeOutValue: (state, action) => {
      localStorage.setItem('timeOutValue', action.payload.timeOutValue)
      state.timeOutValue = action.payload.timeOutValue
    },
    setTimeZone: (state, action) => {
      state.timeZone = action.payload.timeZone
    },
    setHasNewRental: (state, action) => {
      state.hasNewRental = action.payload
      if (action.payload) {
        state.latestRentalNotification = Date.now()
      }
    },
    setHasNewDeposit: (state, action) => {
      state.hasNewDeposit = action.payload
      if (action.payload) {
        state.latestDepositNotification = Date.now()
      }
    },
    clearRentalNotification: (state) => {
      state.hasNewRental = false
    },
    clearDepositNotification: (state) => {
      state.hasNewDeposit = false
    },
    setModalObject: (state, action) => {
      state.modalObject = action.payload.modalObject
      state.vehicleFees.BASE = action.payload.modalObject?.fees?.BASE
      state.vehicleFees.BOOKING = action.payload.modalObject?.fees?.BOOKING
      state.vehicleFees.CANCELLATION = action.payload.modalObject?.fees?.CANCELLATION
      state.vehicleFees.MIN_CHARGES = action.payload.modalObject?.fees?.MIN_CHARGES
      state.vehicleFees.PER_MILE = action.payload.modalObject?.fees?.PER_MILE
      state.vehicleFees.PER_MINUTE = action.payload.modalObject?.fees?.PER_MINUTE
    },
    setVehicleFees: (state, action) => {
      state.vehicleFees.IS_PET_ALLOWED = JSON.parse(action.payload.vehicleFees.IS_PET_ALLOWED)
      state.vehicleFees.BASE = JSON.parse(action.payload.vehicleFees.BASE)
      state.vehicleFees.BOOKING = JSON.parse(action.payload.vehicleFees.BOOKING)
      state.vehicleFees.CANCELLATION = JSON.parse(action.payload.vehicleFees.CANCELLATION)
      state.vehicleFees.MIN_CHARGES = JSON.parse(action.payload.vehicleFees.MIN_CHARGES)
      state.vehicleFees.PER_MILE = JSON.parse(action.payload.vehicleFees.PER_MILE)
      state.vehicleFees.PER_MINUTE = JSON.parse(action.payload.vehicleFees.PER_MINUTE)
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  setSideBarShow,
  setSideBarUnfoldable,
  setAdminToken,
  deleteAdminToken,
  setShowLoader,
  setAdminType,
  setProfile,
  setPoolingInterval,
  setTimeOutValue,
  setTimeZone,
  setHasNewRental,
  setHasNewDeposit,
  clearRentalNotification,
  clearDepositNotification,
  setModalObject,
  setVehicleFees,
} = generalSlice.actions

export default generalSlice.reducer
